import createIcon from '../../createIcon';

/**
 * @component @name ViewCompact
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxOEg2LjVWMTUuNUg0VjE4Wk00IDEzLjI1SDYuNVYxMC43NUg0VjEzLjI1Wk00IDguNUg2LjVWNkg0VjguNVpNMTcuNSA2VjguNUgyMFY2SDE3LjVaTTEzIDguNUgxNS41VjZIMTNWOC41Wk0xNy41IDE4SDIwVjE1LjVIMTcuNVYxOFpNMTcuNSAxMy4yNUgyMFYxMC43NUgxNy41VjEzLjI1Wk04LjUgMThIMTFWMTUuNUg4LjVWMThaTTEzIDE4SDE1LjVWMTUuNUgxM1YxOFpNOC41IDguNUgxMVY2SDguNVY4LjVaTTEzIDEzLjI1SDE1LjVWMTAuNzVIMTNWMTMuMjVaTTguNSAxMy4yNUgxMVYxMC43NUg4LjVWMTMuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewCompact = createIcon('ViewCompact', [
  [
    'path',
    {
      d: 'M4 18H6.5V15.5H4V18ZM4 13.25H6.5V10.75H4V13.25ZM4 8.5H6.5V6H4V8.5ZM17.5 6V8.5H20V6H17.5ZM13 8.5H15.5V6H13V8.5ZM17.5 18H20V15.5H17.5V18ZM17.5 13.25H20V10.75H17.5V13.25ZM8.5 18H11V15.5H8.5V18ZM13 18H15.5V15.5H13V18ZM8.5 8.5H11V6H8.5V8.5ZM13 13.25H15.5V10.75H13V13.25ZM8.5 13.25H11V10.75H8.5V13.25Z',
      key: '1hf4di',
    },
  ],
]);

export default ViewCompact;
